import React from 'react';
const CART_URL = 'https://elcodigodubai.shop//cart/add?id=42982083723354&quantity=1';
interface CTAButtonProps {
  href?: string;
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  className?: string;
  onClick?: () => void;
  showUrgency?: boolean;
  isCheckout?: boolean;
}
export function CTAButton({
  href = '#checkout',
  children,
  variant = 'primary',
  className = '',
  onClick,
  showUrgency = true,
  isCheckout = false
}: CTAButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold uppercase tracking-[0.15em] transition-all duration-300 text-[14px] min-h-[56px] px-8 w-full rounded-none text-center';
  const variants = {
    primary: 'bg-pain text-white hover:bg-[#C4503E] hover:-translate-y-0.5 shadow-lg hover:shadow-[0_8px_24px_rgba(155,58,42,0.35)]',
    secondary: 'bg-primary text-white hover:bg-primary-dark hover:-translate-y-0.5 shadow-lg hover:shadow-xl'
  };
  const finalHref = isCheckout ? CART_URL : href;
  return <div className={`flex flex-col items-center w-full ${className}`} data-id="element-250">
      <a href={finalHref} className={`${baseStyles} ${variants[variant]}`} data-cta={variant} onClick={onClick} data-id="element-251">
        {children}
      </a>
      {showUrgency && <span className="text-[11px] italic text-muted mt-2 text-center block w-full" data-id="element-252">
          El precio sube a $27 después de las primeras 500 familias
        </span>}
    </div>;
}